export class Env {
    public static  DEBUG = true;
}
